import React, { Component } from "react";

import PropTypes from "prop-types";

import { fade, withStyles } from "@material-ui/core/styles";
import * as Yup from 'yup';
import { Formik, useFormik, yupToFormErrors } from 'formik';
import {
    DialogContent,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemSecondaryAction,
    FormControl,
    FormControlLabel,
    InputLabel,
    Input,
    Select,
    MenuItem,
    Divider,
    Hidden,
    Checkbox,
    Switch,
    Button,
    Paper,
    Typography,
    TextField,
    Grid,
} from "@material-ui/core";
import Loader from "../../components/Loader"
import InternalForm from "./InternalForm";
import { auth, storage, firestore, analytics } from "../../firebase";
import moment from "moment";

import {
    FiberManualRecord as FiberManualRecordIcon,
    Brightness4 as Brightness4Icon,
    FormatColorReset as FormatColorResetIcon,
    Photo as PhotoIcon
} from "@material-ui/icons";

const styles = (theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    title: {
        flexGrow: 1,
        padding: '8px 16px',
        color: 'rgba(2, 2, 2, 0.7)',
        backgroundColor: '#F3F6FF',
        display: 'flex',
        justifyContent: 'flex-start'
      },
      actionArea: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'flex-end'
      },
      saveButton: {
        color: '#ffffff',
        backgroundColor: '#3076CA',
        '&:hover': {
          backgroundColor: fade('#3076CA', 0.75),
        },
        margin: '8px 8px;',
        textTransform: 'capitalize'
      },
      cancelButton: {
        margin: '8px 8px;',
        textTransform: 'capitalize'
      }
});

class BaseForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            row: null,
            loading: false,
            isPendingUpload: false
        };
    }

    componentDidMount = () => {
        this.fetchRow()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.rowId != this.props.rowId) {
            this.fetchRow()
        }
    }

    fetchRow = () => {
        const { rowId, row, meta, openSnackbar } = this.props;
        if (rowId) {
            this.setState({loading: true})
            let docRef = {};
            if(meta.getEditDocRef){
                docRef = meta.getEditDocRef(row);
            } else {
                docRef = firestore.collection(meta.collection).doc(rowId);
            }
            const doc = docRef.get().then(doc => {
                if(doc.exists){
                    const id = doc.id;
                    const data = doc.data()
                    this.setState({ row: { id, ...data }, loading: false });
                }else{
                    this.setState({ row: meta.emptyRow(), loading: false });        
                }
            }).catch((err) => {
                openSnackbar('Error Loading data', 'error');
                this.setState({loading: false})
            });
        } else {
            this.setState({loading: false})
            this.setState({ row: meta.emptyRow() });
        }
    }

    handleChange = (e) => {
        const name = e.target.name;
        const type = e.target.type;
        const value = (type == 'checkbox') ? e.target.checked : e.target.value;
        const { row } = this.state;
        if (type == 'file') {
            const nativeFile = e.target.files[0];
            this._getBase64(nativeFile, (dataUrl) => {
                row[name] = dataUrl;
                row.fileName = nativeFile.name
                row.uploadFieldName = name
                this.setState({ row: row, isPendingUpload: true })
            }, error => {
                this.props.openSnackbar("Error Converting File", 'error');
            })
        } else {
            row[name] = value;
        }
        this.setState({ row: row })
    }

    _getBase64 = (file, success, failure) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            success(reader.result);
        };
        reader.onerror = function (error) {
            failure(error);
        };
    }

    updateData = (doc) => {
        const { meta, hideForm, handleRefresh, openSnackbar, onlyForm } = this.props;
        let ref = {};
        if(meta.getEditDocRef){
            ref = meta.getEditDocRef(doc)
        } else{
            ref = firestore.collection(meta.collection).doc(doc.id);
        }
        ref.update(doc).then(() => {
            hideForm()
            openSnackbar(meta.entityName + ' updated successfully', 'success')
            if(onlyForm){
                this.fetchRow()
            }else{
                handleRefresh()
            }
            analytics.logEvent(meta.collection + '-updated', {
                source: 'web'
            })
        }, err => {
            // debugger;
            this.setState({loading: false})
            openSnackbar('Error Updating ' + meta.entityName, 'error')
        })
    }

    createData = (doc) => {
        const { meta, hideForm, handleRefresh, openSnackbar, onlyForm, rowId } = this.props;
        const ref = firestore.collection(meta.collection);
        let docRef = rowId ? ref.doc(rowId) : ref.doc();
        if(meta.getCreateDocRef){
            docRef = meta.getCreateDocRef(doc);
        }
        docRef.set(doc).then(() => {
            hideForm()
            openSnackbar(meta.entityName + ' created successfully', 'success')
            if(onlyForm){
                this.fetchRow()
            }else{
                handleRefresh()
            }
            analytics.logEvent(meta.collection + '-created', {
                source: 'web'
            });
            const metaRef = firestore.collection('_meta').doc(meta.collection);
            firestore.runTransaction(function(transaction) {
                // This code may get re-run multiple times if there are conflicts.
                return transaction.get(metaRef).then(function(sfDoc) {
                    if (!sfDoc.exists) {
                        transaction.set(metaRef, { count: 1 });
                        // throw "Count does not exist!";
                    }else{
                        var newCount = sfDoc.data().count + 1;
                        transaction.update(metaRef, { count: newCount });
                    }
                });
            }).then(function() {
                console.log("Count successfully Updated!");
            }).catch(function(error) {
                console.log("Count update failed: ", error);
            });
            // const metaRef = firestore.collection('_meta').doc(meta.collection);
            //     metaRef.get().then((metaDoc)=> {
            //         // debugger;
            //         var newCount = metaDoc.data().count + 1;
            //         metaRef.update({'count': newCount}).then(() => {
            //             // debugger;
            //         }, err => {
            //             // debugger;
            //             openSnackbar("Error Updating Count", 'error');
            //         })
            //     }).catch((err)=> {
            //         debugger;
            //         openSnackbar("Error Updating Count", 'error');
            //     })
        }, err => {
            this.setState({loading: false})
            openSnackbar('Error Saving new ' + meta.entityName, 'error')
        });
    }

    isBase64 = (media) => {
        if (media instanceof Boolean || typeof media === 'boolean') {
            return false
        }
        const regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+\/]{3}=)?'
        const mimeRegex = '(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)'
        const newRegex = mimeRegex + '?' + regex

        return (new RegExp('^' + newRegex + '$', 'gi')).test(media)
    }

    makeid = (length) => {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    onSave = async (doc) => {
        const { user, meta } = this.props;
        const { onlyForm, loading } = this.state;
        doc = await this._beforeSave(user, doc);
        this.setState({loading: true})

        for(let i=0; i< meta.fields.length; i++){
            if(meta.fields[i].input == 'file') {
                const media = doc[meta.fields[i].name];
                if(this.isBase64(media)){
                    const storageUrl = await this._uploadToStorage(this.makeid(6), media, {});
                    doc[meta.fields[i].name] = storageUrl;
                }
            }
        }

        if(meta.settingsFields && doc.input == 'file') {
            const media = doc.value;
            if(this.isBase64(media)){
                const storageUrl = await this._uploadToStorage(this.makeid(6), media, {});
                doc.value = storageUrl;
            }
        }
        
        if (doc.id) {
            this.updateData(doc)
        } else {
            this.createData(doc)
        }
    }

    _uploadToStorage = (fileName, dataUrl, meta) => {
        return new Promise((resolve, reject) => {
            const storageRef = storage.ref('posts');
            const fileRef = storageRef.child(fileName)
            const uploadTask = fileRef.putString(dataUrl, 'data_url')
            uploadTask.on('state_changed', progress => {
                //loader
            }, err => {
                reject(err);
            }, () => {
                // debugger
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    // debugger;
                    resolve(downloadURL)
                }, err => {
                    reject(err)
                    this.props.openSnackbar('Error Saving new ' + meta.entityName, 'error')
                });
            })
        })
    }

    _beforeSave = async (user, doc) => {
        const { meta } = this.props;
        doc = await meta.beforeSave(user, doc);
        //who columns
        if (doc.id) {
            doc._updatedOn = new Date().getTime();
        } else {
            doc._createdOn = new Date().getTime();
        }

        if (user) {
            doc._owner = {
                id: user.uid,
                displayName: user.displayName,
                email: user.email
            }
        }
        //search columns
        if(meta.searchableColumns)  { doc._searchTerms = this._getSearchTerms(doc, meta.searchableColumns); }
        return doc;
    }

    //Utility Method to get search Terms from Attributes 
    _getSearchTerms = (doc, attributes) => {
        let terms = [];
        try {
            attributes.forEach(attr => {
                const value = doc[attr];
                // value.split(' ').forEach(word => {
                    if(value.length > 3){
                        for (let i = 3; i <= value.length; i++) {
                            const term = value.substring(0, i)
                            terms.push(term.toLowerCase())
                        }
                    }else{
                        terms.push(value.toLowerCase())
                    }
                // })
            })
        } catch (e) {
            console.log('Error getting search terms');
        }
        return terms;
    }

    onCancel = () => {
        this.props.hideForm();
    }

    getInitialRow = (meta, row) => {
        let initialVal = {};
        if(row){
            meta.fields.forEach(field=>{
                let val = undefined;
                if(field.dataType == 'timestamp'){
                    if(row[field.name] != undefined){
                        val = moment.unix(row[field.name]).format('YYYY-MM-DDTHH:mm');
                    }
                }else{
                    val = row[field.name];
                }
                initialVal[field.name] = val;
            })

            if(row.id){
                initialVal.id = row.id;
            }
        }
        return initialVal;
    }

    render() {
        const { meta, onlyForm, selectInputItems, lang } = this.props;
        const { row, loading } = this.state;
        const initialRow = this.getInitialRow(meta, row);
        return (
            <Box style={{ width: '600px' }}>
                
                {
                    loading ? <Loader /> :
                        row && <InternalForm initialRow={initialRow}
                            
                            handleCancel={this.onCancel}
                            handleSave={this.onSave}
                            meta={meta} 
                            onlyForm={onlyForm}
                            lang={lang}
                            selectInputItems={selectInputItems}
                            classes={this.props.classes}/>
                }
            </Box >
        )
    }
}

BaseForm.propTypes = {

};

export default withStyles(styles)(BaseForm);
